import { IsAuth } from '../auth';
import { Layout } from './layout';

export const LayoutAuth = ({ children }) => (
  <IsAuth>
    <Layout>{children}</Layout>
  </IsAuth>
);
